import { Button } from "@mui/material";
import { ICellRendererParams } from "ag-grid-enterprise";
import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { getLabelTagDetails } from "../../../config/axios/apis/labelTags/labelTagsAPI";
import { toastError } from "../../../utils/AppUtils";
import GridHighlightedValue from "../../../components/OrderGridV3/GridHighlightedValue/GridHighlightedValue";

const CountCellRenderer = (value: number | null | "", params: ICellRendererParams) => {
    const { data, node } = params;
    const [count, setCount] = useState(value);
    const [loading, setLoading] = useState(false);

    const handleFetchCount = useCallback(
        async (e: React.MouseEvent) => {
            e.stopPropagation();

            const rowId = data?.id;

            if (!rowId || loading) {
                return;
            }

            setLoading(true);

            try {
                const res = await getLabelTagDetails(rowId, {});
                if (res?.data) {
                    const fetchedCount = res.data.taggedInstancesCount;
                    setCount(fetchedCount);
                    node.setDataValue("count", fetchedCount);
                }
            } catch (error: any) {
                toastError(error?.response?.data?.message ?? error?.message);
            } finally {
                setLoading(false);
            }
        },
        [data?.id, node, loading],
    );

    if (count !== null && count !== undefined && count !== "") {
        return (
            <span>
                <GridHighlightedValue {...params} columnKey="count" value={count} enableCopyToClipboard />
            </span>
        );
    }

    return (
        <Button size="small" variant="CTA" loading={loading} onClick={handleFetchCount} sx={{ fontSize: "0.75rem", py: 0 }}>
            <FormattedMessage id="label-tags.label.check-count" defaultMessage="Check Count" />
        </Button>
    );
};

export default CountCellRenderer;
